module.exports = __webpack_public_path__ + "static/img/1-1.ff6e81a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/1-1.png
// module id = Bs0v
// module chunks = 0